exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-slider__container__3jZhg{position:relative;overflow:hidden;-ms-flex-positive:1;flex-grow:1;height:100%}.content-slider__content__2L919{position:absolute;left:0;top:0;bottom:0;transition:transform .5s}", ""]);

// exports
exports.locals = {
	"container": "content-slider__container__3jZhg",
	"content": "content-slider__content__2L919"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/content-slider/content-slider.styl
// module id = 2908
// module chunks = 1